import axios from "axios";
import { LOGIN_API_URL } from "../constants";

export const authenticateWithGoogle = async ({ code, codeVerifier }) => {
  const response = await axios.post(
    `${LOGIN_API_URL}/oauth2/google-auth`,
    {
      code,
      code_verifier: codeVerifier,
    },
    {
      withCredentials: true,
    },
  );

  return response.data;
};
